import { shallowEqual, useSelector } from 'react-redux'

import { ActionIconWrapper } from '@components/Inbox/TitleBar/TitleBar.styled'
import ActionIcon from '@components/UI/ActionIcon'
import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { useIntl } from '@context/Internationalization/useIntl'
import { EventTrackingNames } from '@enums'
import { ICampaign, selectIsUnlockedCampaign } from '@store/campaigns'
import { IApplicationState } from '@store/index'
import { ISubmission } from '@store/submissions'
import Theme from '@theme'
import { useRateCardTrigger } from './useRateCardTrigger'

interface IProps {
  campaign: ICampaign
  submission: ISubmission
  rateCardCurrency?: string
}

const SubmissionRateCardPanelTriggerDesktop: React.FC<IProps> = ({
  submission,
  campaign,
  rateCardCurrency,
}) => {
  const { intl } = useIntl()
  const { onClick, rateCardTipId } = useRateCardTrigger()
  const { isUnlocked } = useSelector((state: IApplicationState) => ({
    isUnlocked: selectIsUnlockedCampaign(state, campaign.id),
  }), shallowEqual)

  if (isUnlocked) {
    return null
  }

  return (
    <ActionIconWrapper>
      <ConnectedTrackedRoute
        submissionId={submission.id}
        campaignId={campaign.id}
        eventName={EventTrackingNames.ToolbarViewRateCard}
      >
        <ActionIcon
          onClick={onClick}
          glyph={`rate-card-${rateCardCurrency}`}
          color={Theme.grey900Color}
          size={1.5}
          tooltip={intl.formatMessage({ id: rateCardTipId })}
          elementName="rate-card"
        />
      </ConnectedTrackedRoute>
    </ActionIconWrapper>
  )
}

export default SubmissionRateCardPanelTriggerDesktop
